import { createAction } from 'redux-actions';
// ------------------------------------
// Actions
// ------------------------------------

export const getTrendsHash: any = createAction('trends/GET_TRENDS_HASH', (trends: State.Trends) => () => {
  return trends;
});
